import { styled, css, Theme } from '@core-ui/react-stitch';

interface DividerProps {
  theme?: Theme;
}
const getDividerStyles = ({ theme }: DividerProps) =>
  css({
    alignSelf: 'center',
    height: '1.15rem',
    borderLeft: `1px solid ${theme?.color?.g3}`,
  });
const Divider = styled.div<DividerProps>`
  ${getDividerStyles};
`;

export default Divider;
